import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/statistic",

        async dayData({ page }) {
            const url = this.url(`/general/table/${page}`);

            return Vue.http.get(url);
        },

        overview() {
            const url = this.userUrl({ path: `/general-view` });

            return Vue.http.get(url);
        },

        async getTopLocalAccess(payload) {
            return Vue.http.get('/core/statistic/local/top/access', {
                params: buildQueryParams({
                    ...payload
                })
            })
        },

        async overviewAdmin({
            date,
            advertising,
            users,
            establishments,
            local
        } = {}) {
            const url = this.url(`/general`);

            return await Vue.http.get(url, {
                params: {
                    campaigns: advertising,
                    users,
                    establishments,
                    locals: local,
                    startDate: date.min,
                    endDate: date.max
                }
            });
        },

        async load({ date, advertising, users, establishments, local }) {
            const url = this.userUrl({
                path: `/`
            });

            return Vue.http.get(url, {
                params: buildQueryParams({
                    date, advertising, users, establishments, local
                })
            });
        },

        async excell({ filters }) {
            return Vue.http({
                url: this.userUrl({ path: `/excel` }),
                method: "GET",
                responseType: "blob", // important
                params: buildQueryParams(filters)
            });
        },

        async excellPartnerCampaignReport({ campaigns, startDate, endDate, establishments}) {
            const query = {
                campaigns,
                startDate,
                endDate,
                establishments,

            };
            return Vue.http({
                url: this.url(`/excel/partner`),
                method: "GET",
                responseType: "blob", // important
                params: query
            });
        },

        async heatTable({
            date,
            local
        }) {
            const url = this.url(`/heat-table/2`);

            return Vue.http.get(url, {
                params: {
                    startDate:  date && date.min,
                    endDate: date && date.max,
                    locals: local,
                }
            });
        }
    },
    base
);

const buildQueryParams = ({
    date,
    devices,
    advertising,
    users,
    establishments,
    local
} = {}) => {
    return {
        campaigns: advertising,
        users,
        establishments,
        locals: local,
        startDate:  date && date.min,
        endDate: date && date.max,
        devices,
    };
};
